import styled, { css } from 'react-emotion';
import theme from '@lyearn-team/theme-config';

export const content = css`
  width: 100%;
  height: 100%;
  padding: 0;
`;

export const troubleLoginEmail = css`
  margin: 24px 0 20px;
  display: flex;
  flex-direction: column;
  .text-info {
    text-align: center;
    margin-bottom: 30px;
    color: ${theme.color.dark.silver};
    line-height: 1.71;
  }

  .box-input {
    margin-bottom: 28px;
  }
  @media (max-width: 767px) {
    flex-grow: 1;
  }
`;

export const troubleLoginForm = css`
  display: flex;
  justify-content: space-between;
  flex-direction: column;
  flex-grow: 1;
`;

export const ContactLyearnText = styled.div`
  font-size: 12px;
  line-height: 17px;
  text-align: center;
  width: 100%;
  color: ${theme.color.dark.iron};
  a {
    cursor: pointer;
    text-decoration: underline;
    color: ${theme.color.dark.amethyst};
    :hover {
      color: ${theme.color.dark.iron};
    }
  }
  @media (min-width: 767px) {
    margin-bottom: 37px;
  }
  @media (max-width: 767px) {
    margin: 40px 0 0px;
  }
`;

export const BackToSignInWrapper = styled.div`
  display: flex;
  justify-content: center;
  @media (min-width: 767px) {
    margin: 40px 0;
  }
`;

export const inputClass = css`
  padding: 10px 20px;
  :-internal-autofill-selected {
  }
  @media (max-width: 767px) {
    width: 100%;
  }
`;

export const buttonClass = css`
  width: 100%;
  line-height: 16px;
  padding: 10px 16px;
`;

export const IconWrapper = styled.div`
  ${({ color }) => `
    background-color: ${color};
    border-radius: 50%;
    height: 42px;
    width: 42px;
    padding: 3px;
    display: flex;
    align-items: center;
    justify-content: center;
    margin-right: 12px;
    flex-shrink: 0;
  `};
`;

export const FixMargin = styled.div`
  @media (max-width: 767px) {
    height: 60px;
  }
`;

export const GreyWrapper = styled.div`
  padding: 32px 54px 54px;
  margin-top: 35px;
`;

export const ResponseStatusText = styled.div`
  display: flex;
  flex-direction: row;
  align-items: center;
  color: ${theme.color.dark.emerald};
  font-size: 14px;
  font-weight: 500;
  padding: 0px 0px 25px;
  margin-top: 46px;
  justify-content: center;
`;

export const ResponseStatusInstructions = styled.div`
  display: inline;
  font-size: 14px;
  color: ${theme.color.dark.silver};
  line-height: 1.57;
  text-align: center;
  justify-content: center;

  .bold-text {
    font-weight: bold;
    display: inline;
  }

  @media (max-width: 767px) {
    margin-bottom: 40px;
  }
  .mail-link {
    color: ${theme.color.dark.silver};
  }
`;
